import clsx from 'clsx';
import {AlertProps} from './Types';
import {useI18n} from '../../providers/I18nProvider';

export default function SuccessAlert({
	message,
	title,
	extraClasses = '',
	showIcon = false,
	showTitle = false,
}: AlertProps) {
	const {i18n} = useI18n();

	return (
		<div
			className={clsx(
				`bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative ${extraClasses}`,
				{
					'text-center': !showIcon,
				},
			)}
			role='alert'
		>
			{showTitle && <strong className='font-bold'>{title || 'Success!'} </strong>}
			<span className='block sm:inline'>{message}</span>
			{showIcon && (
				<span className='absolute top-0 bottom-0 right-0 px-4 py-3'>
					<svg
						className='fill-current h-6 w-6 text-green-500'
						role='button'
						xmlns='http://www.w3.org/2000/svg'
						viewBox='0 0 20 20'
					>
						<title>{i18n('COMMON.CLOSE')}</title>
						<path d='M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z' />
					</svg>
				</span>
			)}
		</div>
	);
}
